import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: 70px auto 80px;
`;

export const Title = styled.h2`
  font-size: 1.3em;
  font-weight: bold;
  margin: 18px 20px;
`;

export const Content = styled.div`
  margin: 0 18px;
`;

export const ContentTh = styled.th`
  text-align: right;
  font-weight: normal;
  padding: 4px 12px 4px 6px;
`;

export const ContentText = styled.input`
  height: 20px;
  width:125%;
  font-size: 0.9em;
  box-sizing: content-box;
`;

export const ContentNum = styled.input`
  width: 100px;
  height: 20px;
  box-sizing: content-box;
`;
export const Ahref = styled.a`
  text-decoration: none;
  color: #333333;
`;



export const ButtonCell = styled.div`
  display:flex;
  -webkit-justify-content: flex-end;;
    justify-content: flex-end;;
    -webkit-align-items: flex-end;;
    align-items:flex-end;;
  padding: 20px;
`;

export const ButtonSave = styled.button`
  display: inline-block;
  border-radius: 4px;
  box-shadow:1px 1px 0.5px 0.5px rgba(3,3,3,0.3);
  &.active{
    box-shadow: inset 0 0 1px 0.5px rgba(3,3,3,0.3);
  }
  :disabled { 
    opacity:0.4;
  }
  cursor: pointer;
  min-width: 3em;
  text-align: center;
  padding: 2px 12px;
  margin-left: 6px;
  color: #333333;
  font-size: 1em;
  border:none;
  text-align:center;
  background-color:lightgray;
  border-color:lightgray;
`;

export const ButtonSearch = styled.button`
  display: inline-block;
  margin-left:10px;
  border-radius: 4px;
  box-shadow:1px 1px 0.5px 0.5px rgba(3,3,3,0.3);
  min-width: 3em;
  text-align: center;
  padding: 2px 12px;
  color: #333333;
  font-size: 1em;
  border:none;
  background-color:lightgray;
  border-color:lightgray;
`;


export const ButtonClear = styled.button`
  display: inline-block;
  margin-left:300px;
  border-radius: 4px;
  box-shadow:1px 1px 0.5px 0.5px rgba(3,3,3,0.3);
  min-width: 3em;
  text-align: center;
  padding: 2px 12px;
  color: #333333;
  font-size: 1em;
  border:none;
  background-color:lightgray;
  border-color:lightgray;
`;
export const Pop = styled.div`
  position: absolute;
  width:100%;
  z-index: 10;
  top: 50%;
  right: calc(50%);
  transform: translateY(-30%);
  background-color: #fff;
  color: black;
  padding: 0.5em 1em;
  border-radius: 5px;
`;

export const TooltipCo = styled.div`
  position: relative;
  display: inline - block;
`;

export const ListTable = styled.table`
  width:100%;
  border-collapse: collapse;
  border:1px solid lightgray;
  thead th {
    border-collapse: collapse;
    border:1px solid lightgray;
    background-color:#f2f2f2;
    min-width: 5.1em;
    font-weight: bold;
    padding:5px;
    text-align:center;
    vertical-align: middle;
    padding: 4px 6px;
  }
  tbody td {
    border-collapse: collapse;
    border:1px solid lightgray;
    text-align:left;
    vertical-align: top;
    padding: 4px 8px;
  }
`;

export const ListTr = styled.tr`
  border-collapse: collapse;
  border:1px solid lightgray;
`;

export const ListCodeTd = styled.td`
  word-break: break-all;
  min-width: 8em;
`;

export const CheckTh = styled.th`
  min-width: 1em !important;
`;

export const Listhref = styled.a`
  color:blue;
  text-decoration:underline;
  cursor: pointer;
`;


export const ListkeyTd = styled.td`
  border-collapse: collapse;
  border: 0px none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width:100rem;
  padding: 4px 8px;
`;

export const ListNumberTd = styled.td`
  text-align:right !important;
`;

export const ListNameTd = styled.td`
  border-collapse: collapse;
  border:1px solid lightgray;
  vertical-align: top;
  width:15em;
  padding: 4px 8px;
`;

// export const Pagination = styled.td`
//   text-align: center; 
//   width: 100%;
//   margin: 30px auto;
//   display:flex;
//   -webkit-justify-content: center;
//   justify-content: center;
//   -webkit-align-items: center;
//   align-items:center;
// `;

export const SerchTable = styled.table`
  margin-top:10px;
`;
export const Serch = styled.div`
  display: flex;
  padding-top:5px;
  padding-bottom:  20px;
  border-bottom: #f2f2f2 1.5px solid;
`;

export const SerchTd = styled.td`
  padding-right:100px;
`;

export const SerchUnitTd = styled.td`
  padding:0;
`;
export const ListKeySurroundTd = styled.td`
  border-collapse: collapse;
  border:1px solid lightgray;
`;
export const ContentTime = styled.input`
  margin-left:5px;
`;

export const PaginationLi = styled.li`
  display:inline-block;
  margin:5px;
  font-size:30px;
  text-align:center;
`;

export const PaginationUl = styled.ul`
  margin: auto;
`;

export const NgReasonSelect = styled.select`
  font-size:10px;
`;

export const Chceckdiv = styled.div`
  margin:5px;
  display:inline-block
`;

export const Pagination = styled.div`
  text-align: center; 
  width: 100%;
  margin: 30px auto 15px auto;
  display:flex;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items:center;
`;